import React from "react";
import { Route } from "react-router-dom";
import { lazyPage } from "./lazyPage";

const Logout = lazyPage(() => import("../components/login/Logout"));
const Register = lazyPage(() => import("../components/login/Register"));
const Login = lazyPage(() => import("../components/login/Login"));
const Error404 = lazyPage(() => import("../pages/Error404"));
const LandingPage = lazyPage(() => import("../pages/LandingPage"));
const Contact = lazyPage(() => import("../pages/Contact"));
const Blog = lazyPage(() => import("../pages/Blog"));
const EventsConferences = lazyPage(() => import("../pages/EventsConferences"));
const Databases = lazyPage(() => import("../pages/Databases"));
const Tools = lazyPage(() => import("../pages/Tools"));
const Media = lazyPage(() => import("../pages/Media"));
const Books = lazyPage(() => import("../pages/Books"));
const Articles = lazyPage(() => import("../pages/Articles"));
const About = lazyPage(() => import("../pages/about2"));
const PrivacyPolicy = lazyPage(() => import("../pages/PrivacyPolicy"));
const TermsConditions = lazyPage(() => import("../pages/TermsConditions"));
const BlogDetailsContent = lazyPage(() =>
  import("../components/blog/BlogDetailsContent")
);
const ProductDetails = lazyPage(() =>
  import("../components/Shop/ProductDetails")
);
const Profile = lazyPage(() => import("../pages/Profile"));
const ResetPassword = lazyPage(() => import("../pages/ResetPassword"));
const ConfirmEmail = lazyPage(() => import("../pages/ConfirmEmail"));

const routes = [
  <Route path="/" element={<LandingPage />} key="home" />,
  <Route path="/about" element={<About />} key="about" />,
  <Route path="/contact" element={<Contact />} key="contact" />,
  <Route path="/articles" element={<Articles />} key="articles" />,
  <Route path="/books" element={<Books />} key="books" />,
  <Route
    path="/books/rna-made-simple"
    element={<ProductDetails />}
    key="books-details"
  />,
  <Route path="/media" element={<Media />} key="media" />,
  <Route path="/tools" element={<Tools />} key="tools" />,
  <Route path="/databases" element={<Databases />} key="databases" />,
  <Route
    path="/events-conferences"
    element={<EventsConferences />}
    key="events-conferences"
  />,
  <Route path="/blog" element={<Blog />} key="blog" />,
  <Route
    path="/blog/:slug"
    element={<BlogDetailsContent />}
    key="blog-details"
  />,
  <Route path="/christian-siadjeu" element={<Profile />} key="profile" />,
  <Route path="/privacy-policy" element={<PrivacyPolicy />} key="privacy-policy" />,
  <Route
    path="/terms-conditions"
    element={<TermsConditions />}
    key="terms-conditions"
  />,
  <Route path="/login" element={<Login />} key="login" />,
  <Route path="/logout" element={<Logout />} key="logout" />,
  <Route path="/register" element={<Register />} key="register" />,
  <Route
    path="/reset-password"
    element={<ResetPassword />}
    key="reset-password"
  />,
  <Route path="/confirm-email" element={<ConfirmEmail />} key="confirm-email" />,
  <Route path="*" element={<Error404 />} key="error404" />,
];

export default routes;
